import { render, staticRenderFns } from "./DiscountPix.vue?vue&type=template&id=7f806364&"
import script from "./DiscountPix.vue?vue&type=script&lang=js&"
export * from "./DiscountPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports